<script lang="ts">
import { defineComponent } from 'vue';
import Notify from '~/widgets/Notify';
import SoftwareHelper from '~/helpers/SoftwareHelper';
import SoftwareTrackersConfigApiClient from '~/apiClients/SoftwareTrackersConfigApiClient';
import BaseConfigurationPublisher from './BaseConfigurationPublisher.vue';
import SoftwareApiClient from '../../apiClients/SoftwareApiClient';
import { Software } from '~/models/Software';
import PublishButtonStatusUpdate from '../../windowEvents/PublishButtonStatusUpdate';

export default defineComponent({
  name: 'SoftwareConfigurationPublisher',
  extends: BaseConfigurationPublisher,
  data() {
    return {
      title: 'Publish trackers configuration',
    };
  },
  async beforeMount() {
    await this.setButtonStatus();
    window.addEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  beforeUnmount() {
    window.removeEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  methods: {
    getApiClient(): SoftwareTrackersConfigApiClient {
      return new SoftwareTrackersConfigApiClient();
    },
    async runPublishing(): Promise<void> {
      const params = SoftwareHelper.getSelectedSoftwareObject();
      if (SoftwareHelper.validateSoftware(params)) {
        const software = await (new SoftwareApiClient()).provideSoftwareById(params.id);
        await this.publishForSoftware(software);
      }
    },
    async publishForSoftware(software: Software): Promise<void> {
      try {
        await this.getApiClient().publish(false, software.id);
        await this.setButtonStatus();
        Notify.success(`Configuration for ${software.name} has been published successfully`, { fadeOut: { delay: 2000 } });
      } catch (e) {
        Notify.error(`Failed to publish configuration for software ${software.name}... ${e.response?.data}`, { fadeOut: { enabled: false } });
      }
    },
    async setButtonStatus() {
      const software = SoftwareHelper.getSelectedSoftwareObject();
      if (SoftwareHelper.validateSoftware(software)) {
        this.isButtonDisabled = await this.getApiClient().getIsPublishedStatus(software.id);
      }
    },
  },
});
</script>
